export const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'us-east-1_9VbCwStHJ',
      userPoolClientId: '8trkun3hdfm03ngugqclo5q7f',
      loginWith: {
        email: true,
        
      }
    }
  }
};
